import { faCheck, faSlash, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyledInput } from "@ui";
import { cx } from "class-variance-authority";
import Loader from "components/Loader";
import { dot } from "dot-object";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { Relative } from "./types";

interface Props {
    relative: Relative;
    clubSlug: string;
}

export const PermissionPreview: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ relative, clubSlug }) => {
    const { t } = useTranslation("general");
    const [search, setSearch] = useState("");
    const { data, isLoading } = useSWR<{
        data: { [x: string]: { label: string; source: string; value: boolean | null } };
    }>(`club/${clubSlug}/permissions/${relative.id}`);

    const dottedData: { [x: string]: { label: string; source: string; value: boolean | null } } = Object.entries(
        dot(data?.data || {})
    ).reduce((carry, [key, value]) => {
        const keyArray = key.split(".");
        const newKey = keyArray.slice(0, keyArray.length - 1).join(".");
        const dataKey = keyArray.slice(-1).join();

        return { ...carry, [newKey]: { ...carry[newKey], [dataKey]: value } };
    }, {});

    return (
        <Loader isLoading={isLoading}>
            {relative.full_access ? (
                <p className="tw-text-center">{t("permissions.preview.superAdminNotice")}</p>
            ) : (
                <>
                    <StyledInput
                        clearable
                        aria-label={t("permissions.common.search")}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder={t("permissions.common.search")}
                    />
                    <div className="tw-grid tw-grid-cols-3 tw-gap-y-4 tw-p-2">
                        {Object.entries(dottedData)
                            .filter(([, { label }]) => label.match(search))
                            .map(([key, { source, label, value }]) => (
                                <React.Fragment key={key}>
                                    <div
                                        className={cx(
                                            "tw-font-bold",
                                            value === true
                                                ? "tw-text-success"
                                                : value === false
                                                ? "tw-text-red-500"
                                                : ""
                                        )}
                                    >
                                        {label}
                                    </div>
                                    <div
                                        className={cx(
                                            "tw-justify-self-end",
                                            value === true
                                                ? "tw-text-success"
                                                : value === false
                                                ? "tw-text-red-500"
                                                : ""
                                        )}
                                    >
                                        {source && t("permissions.preview.source", { source })} {}
                                    </div>
                                    <FontAwesomeIcon
                                        className={cx(
                                            "tw-justify-self-end",
                                            value === true
                                                ? "tw-text-success"
                                                : value === false
                                                ? "tw-text-red-500"
                                                : ""
                                        )}
                                        icon={value === true ? faCheck : value === false ? faTimes : faSlash}
                                    />
                                </React.Fragment>
                            ))}
                    </div>
                </>
            )}
        </Loader>
    );
};
